<template>
  <div>
    <vx-card title="Analytics Settings">
      <!-- <pre> {{moduleList}}</pre>  -->
      <form data-vv-scope="Communicaton_settings">
        <vs-collapse class="custom-collapse settings_collapse">
          <vs-collapse-item
            v-for="(module, index) in moduleList"
            :key="index"
            @click.native="
              getPlatformModulesAndMapSettings(
                module.platform_modules_id,
                module.isLoaded
              )
            "
            :open="module.module_name.toLowerCase() === tabToOpen"
          >
            <div slot="header">
              {{ module.module_name }}
            </div>
            <vs-row>
              <vs-col
                vs-w="4"
                class="p-2"
                v-for="(option, in_index) in module.stats"
                :key="in_index"
              >
                <vs-card class="setting_each_card">
                  <div slot="header" class="flex">
                    <!-- <pre>{{option}}</pre> -->
                    <vs-checkbox
                      :disabled="checkCreatePermission() ? false : true"
                      v-model="option.enabled"
                      @change="
                        toggleOptionSelected(module.platform_modules_id, option)
                      "
                    />
                    <h5>{{ option.option_name }}</h5>
                  </div>
                  <vs-row>
                    <div
                      class="w-full"
                      v-if="
                        option.has_dropdown &&
                        option.enabled &&
                        option.no_of_dropdown == 1 &&
                        [14, 15, 38, 39, 32, 33, 34, 37,48].includes(option.id) ==
                          false &&
                        option.dropdown_list.length > 0
                      "
                    >
                      <v-select
                        v-if="option.has_picture == 1"
                        append-to-body
                        class="w-full"
                        :options="option.dropdown_list"
                        :clearable="false"
                        v-model="option.selected_option_id"
                        :reduce="(option) => option.id"
                        label="name"
                        @input="
                          handleDropDownChnage(
                            option,
                            module.platform_modules_id
                          )
                        "
                      >
                        <template v-slot:selected-option="dropdown_list">
                          <img
                            v-if="dropdown_list.picture"
                            class="person-img rounded-full"
                            :src="dropdown_list.picture"
                          />
                          <img
                            v-else
                            class="person-img rounded-full"
                            src="@/assets/images/pages/user-circle-solid.svg"
                          />
                          {{ dropdown_list.name }}
                        </template>
                        <template v-slot:option="dropdown_list">
                          <img
                            v-if="dropdown_list.picture"
                            class="person-img rounded-full"
                            :src="dropdown_list.picture"
                          />
                          <img
                            v-else
                            class="person-img rounded-full"
                            src="@/assets/images/pages/user-circle-solid.svg"
                          />
                          {{ dropdown_list.name }}
                        </template>
                      </v-select>
                      <v-select
                        v-else
                        append-to-body
                        class="w-full"
                        :options="option.dropdown_list"
                        :clearable="false"
                        v-model="option.selected_option_id"
                        :reduce="(option) => option.id"
                        label="name"
                        @input="
                          handleDropDownChnage(
                            option,
                            module.platform_modules_id
                          )
                        "
                      >
                      </v-select>
                    </div>
                    <div
                      class="w-full"
                      v-if="
                        !option.has_dropdown &&
                        option.enabled &&
                        !option.has_option_date_range &&
                        !option.has_price_range
                      "
                    >
                      <p v-if="option.enabled">Activated</p>
                      <p v-else>Deactivated</p>
                    </div>
                    <div
                      class="w-full"
                      v-if="
                        [14, 15, 38, 39, 32, 33, 34, 37,48].includes(option.id) &&
                        option.enabled
                      "
                    >
                      <v-select
                        v-if="option.has_picture == 1"
                        append-to-body
                        class="w-full"
                        :options="option.dropdown_list"
                        v-model="option.selected_option_id"
                        :clearable="false"
                        multiple
                        :reduce="(option) => option.id"
                        label="name"
                        @input="
                          handleDropDownChnage(
                            option,
                            module.platform_modules_id
                          )
                        "
                      >
                        <template v-slot:selected-option="dropdown_list">
                          <img
                            v-if="dropdown_list.picture"
                            class="person-img rounded-full"
                            :src="dropdown_list.picture"
                          />
                          <img
                            v-else
                            class="person-img rounded-full"
                            src="@/assets/images/pages/user-circle-solid.svg"
                          />
                          {{ dropdown_list.name }}
                        </template>
                        <template v-slot:option="dropdown_list">
                          <img
                            v-if="dropdown_list.picture"
                            class="person-img rounded-full"
                            :src="dropdown_list.picture"
                          />
                          <img
                            v-else
                            class="person-img rounded-full"
                            src="@/assets/images/pages/user-circle-solid.svg"
                          />
                          {{ dropdown_list.name }}
                        </template>
                      </v-select>
                      <v-select
                        v-else
                        append-to-body
                        class="w-full"
                        :options="option.dropdown_list"
                        v-model="option.selected_option_id"
                        :clearable="false"
                        multiple
                        :reduce="(option) => option.id"
                        label="name"
                        @input="
                          handleDropDownChnage(
                            option,
                            module.platform_modules_id
                          )
                        "
                      ></v-select>
                    </div>
                    <div
                      class="w-full"
                      v-if="
                        option.has_option_date_range &&
                        option.has_dropdown == false &&
                        option.enabled
                      "
                    >
                      <flat-pickr
                        class="w-full my-1"
                        icon-pack="feather"
                        icon="icon-calendar"
                        icon-after
                        v-model="option.date_range.startDate"
                        :config="{
                          dateFormat: 'Y-m-d',
                          altInput: true,
                          altFormat: 'j F, Y',
                        }"
                        label="Date"
                        placeholder="Start Date"
                      />
                      <flat-pickr
                        class="w-full my-1"
                        icon-pack="feather"
                        icon="icon-calendar"
                        v-validate="'required'"
                        icon-after
                        v-if="option.date_range.startDate != null"
                        v-model="option.date_range.endDate"
                        :config="{
                          dateFormat: 'Y-m-d',
                          minDate: option.date_range.startDate,
                          altInput: true,
                          altFormat: 'j F, Y',
                        }"
                        label="Date"
                        placeholder="End Date"
                      />
                      <vs-button
                        v-if="option.date_range.endDate"
                        @click="
                          handleDateChnage(
                            option.id,
                            module.platform_modules_id,
                            option.date_range.startDate,
                            option.date_range.endDate
                          )
                        "
                        type="filled"
                        >Save</vs-button
                      >
                    </div>
                    <v-select
                      class="w-full my-1"
                      v-if="
                        option.has_dropdown &&
                        (option.no_of_dropdown == 2 ||
                          option.no_of_dropdown == 3) &&
                        option.enabled &&
                        option.dropdown_list.length > 0
                      "
                      append-to-body
                      :options="option.dropdown_list"
                      v-model="option.selected_parent_option_id"
                      :clearable="false"
                      :reduce="(option) => option.id"
                      label="name"
                      :disabled="option.selected_option_id.length > 0"
                      @input="
                        statusHandleDropDownChange(
                          option.selected_parent_option_id
                        )
                      "
                    >
                    </v-select>
                    <div
                      class="w-full my-1"
                      v-if="
                        (project_status_list.length > 0 ||
                          option.project_status_list) &&
                        option.selected_parent_option_id != '' &&
                        option.enabled &&
                        option.id == 17
                      "
                    >
                      <v-select
                        append-to-body
                        class="w-full"
                        :options="
                          project_status_list.length > 0
                            ? project_status_list
                            : option.project_status_list
                        "
                        v-model="option.selected_option_id"
                        :clearable="false"
                        multiple
                        :reduce="(option) => option.id"
                        label="name"
                        @input="
                          handleDropDownChnage(
                            option,
                            module.platform_modules_id
                          )
                        "
                      >
                      </v-select>
                    </div>
                    <!-- ///only for attendance  modules -->
                    <div
                      class="w-full my-1"
                      v-if="
                        option.teacher_list != '' &&
                        option.no_of_dropdown == 3 &&
                        option.enabled
                      "
                    >
                      <v-select
                        :getOptionLabel="(item) => `${item.name}`"
                        append-to-body
                        class="w-full"
                        :options="option.teacher_list"
                        v-model="option.selected_option_id"
                        :clearable="false"
                        multiple
                        :reduce="(option) => option.id"
                        label="name"
                      >
                        <template v-slot:selected-option="teacher_list">
                          <img
                            v-if="teacher_list.picture"
                            class="person-img rounded-full"
                            :src="teacher_list.picture"
                          />
                          <img
                            v-else
                            class="person-img rounded-full"
                            src="@/assets/images/pages/user-circle-solid.svg"
                          />
                          {{ teacher_list.name }}
                        </template>
                        <template v-slot:option="teachers_list">
                          <img
                            v-if="teachers_list.picture"
                            class="person-img rounded-full"
                            :src="teachers_list.picture"
                          />
                          <img
                            v-else
                            class="person-img rounded-full"
                            src="@/assets/images/pages/user-circle-solid.svg"
                          />
                          {{ teachers_list.name }}
                        </template>
                      </v-select>
                    </div>
                    <div
                      class="w-full"
                      v-if="
                        option.has_option_date_range &&
                        option.selected_parent_option_id != '' &&
                        option.enabled &&
                        module.platform_modules_id == 10
                      "
                    >
                      <flat-pickr
                        class="w-full my-1"
                        icon-pack="feather"
                        v-validate="'required'"
                        icon="icon-calendar"
                        icon-after
                        v-model="option.date_range.startDate"
                        :config="{
                          dateFormat: 'Y-m-d',
                          altInput: true,
                          altFormat: 'j F, Y',
                        }"
                        label="Date"
                        placeholder="Start Date"
                      />
                      <vs-button
                        @click="
                          handleDateAttendance(
                            option,
                            module.platform_modules_id
                          )
                        "
                        type="filled"
                        >Save
                      </vs-button>
                    </div>
                    <div
                      class="w-full"
                      v-if="
                        option.has_option_date_range &&
                        module.platform_modules_id != 10 &&
                        option.selected_parent_option_id != '' &&
                        option.enabled &&
                        option.id != 24 &&
                        option.id != 35 &&
                        option.id != 36 &&
                        option.id != 41
                      "
                    >
                      <flat-pickr
                        class="w-full my-1"
                        icon-pack="feather"
                        v-validate="'required'"
                        icon="icon-calendar"
                        icon-after
                        v-model="option.date_range.startDate"
                        :config="{
                          dateFormat: 'Y-m-d',
                          altInput: true,
                          altFormat: 'j F, Y',
                        }"
                        label="Date"
                        placeholder="Start Date"
                      />
                      <flat-pickr
                        class="w-full my-1"
                        icon-pack="feather"
                        icon="icon-calendar"
                        v-validate="'required'"
                        icon-after
                        v-if="option.date_range.startDate != null"
                        v-model="option.date_range.endDate"
                        :config="{
                          dateFormat: 'Y-m-d',
                          minDate: option.date_range.startDate,
                          altInputaltInput: true,
                          altFormat: 'j F, Y',
                        }"
                        label="Date"
                        placeholder="End Date"
                      />
                      <vs-button
                        v-if="
                          option.date_range.endDate &&
                          option.no_of_dropdown == 2
                        "
                        @click="
                          handleDateChnageCourse(
                            option,
                            module.platform_modules_id
                          )
                        "
                        type="filled"
                        >Save
                      </vs-button>
                      <vs-button
                        v-else-if="
                          option.date_range.endDate &&
                          option.no_of_dropdown == 3
                        "
                        @click="
                          handleDateChnageCourseTeacher(
                            option,
                            module.platform_modules_id
                          )
                        "
                        type="filled"
                        >Save</vs-button
                      >
                    </div>

                    <div
                      class="w-full my-1"
                      v-if="
                        (project_status_list.length > 0 ||
                          option.project_status_list) &&
                        option.selected_parent_option_id != '' &&
                        option.enabled &&
                        option.id == 17"
                    ></div>
                    <template v-if="option.has_price_range && option.enabled">
                 
                      <div class="w-full">
                        <label class="vs-input--label block"
                          >Set Minimum Value</label
                        >
                        <input
                          type="range"
                          min="0"
                          v-model="option.price_range[0]"
                          @change="
                            changePriceRange(stat, item.platform_modules_id)
                          "
                        />
                        <strong class="inline-block m-2">Min.:</strong
                        ><span
                          ><span v-html="currency_code"></span>
                          {{ option.price_range[0] }}</span
                        >
                      </div>
                      <div class="w-full">
                        <label class="vs-input--label block"
                          >Set Maximum Value</label
                        >
                        <input
                          type="range"
                          :min="option.price_range[0]"
                          max="10000"
                          v-model="option.price_range[1]"
                          @change="
                            changePriceRange(stat, item.platform_modules_id)"
                        />
                        <strong class="inline-block m-2">Max.:</strong
                        ><span
                          ><span v-html="currency_code"></span>
                          {{ option.price_range[1] }}</span
                        >
                      </div>
                      <div>
                        <vs-button
                          type="filled"
                          @click="
                            submitPriceRange(option, module.platform_modules_id)
                          "
                          >Go</vs-button
                        >
                      </div>
                    </template>
                  </vs-row>
                </vs-card>
              </vs-col>
            </vs-row>
          </vs-collapse-item>
        </vs-collapse>
      </form>
    </vx-card>
  </div>
</template>

<script>
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import {
  getAllAnalyticsForDashboard,
  platformModuleslist,
  getModuleAnalyticsSettings,
  deleteUserModuleAnalyticsSetting,
  saveUserModuleAnalyticsSetting,
  getStatusList
} from '@/api/analyticsSettings'
export default {
  components: {
    flatPickr,
    vSelect
  },
  mixins: [PermissionMiddleware],
  data () {
    return {
      currency_code: JSON.parse(localStorage.getItem('localization'))
        .currency.currency_symbol,
      customer_id: null,
      tabToOpen: null,
      moduleList: [],
      allAnalyticsData: [],
      test_range: [100, 10000],
      analyticsList: [],
      project_status_list: []
    }
  },
  async created () {
    this.customer_id = await localStorage.getItem('customer_id')
    await this.getModuleList()
    this.tabToOpen = this.$route.query.tab
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Analytics')
    }
    // if (this.tabToOpen !== null) {
    //   const module_id = this.moduleList.filter(moduleItem => {
    //     if (moduleItem.module_name.toLowerCase() === this.tabToOpen) {
    //        return moduleItem.platform_modules_id
    //     }
    //   })
    // await this.getPlatformModulesAndMapSettings(module_id[0].platform_modules_id, false)
    //}
  },
  watch: {
    module_list () {
      this.getModuleList()
    }
  },
  methods: {
    async handleDateAttendance (option, module_name) {
      this.$vs.loading()
      const customer_id = localStorage.getItem('customer_id')
      let updateData = {}
      if (option.selected_option_id) {
        updateData = {
          customer_id,
          multiple_value_id: option.selected_option_id,
          module_id: module_name,
          option_id: option.id,
          startDate: option.date_range.startDate,
          value_id: option.selected_parent_option_id,
          endDate: option.date_range.startDate,
          value_for: 0
        }
      } else {
        updateData = {
          customer_id,
          module_id: module_name,
          option_id: option.id,
          startDate: option.date_range.startDate,
          value_id: option.selected_parent_option_id,
          endDate: option.date_range.startDate,
          value_for: 0
        }
      }
      await saveUserModuleAnalyticsSetting(updateData)
      this.$vs.loading.close()
      const msg = 'Saved successfully'
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    async handleDateChnageCourse (option, module_name) {
      this.$vs.loading()
      const customer_id = localStorage.getItem('customer_id')
      const updateData = {
        customer_id,
        module_id: module_name,
        option_id: option.id,
        startDate: option.date_range.startDate,
        value_id: option.selected_parent_option_id,
        endDate: option.date_range.endDate,
        value_for: 0
      }
      await saveUserModuleAnalyticsSetting(updateData)
      this.$vs.loading.close()
      const msg = 'Saved successfully'
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    async handleDateChnageCourseTeacher (option, module_name) {
      this.$vs.loading()
      const customer_id = localStorage.getItem('customer_id')
      const updateData = {
        customer_id,
        module_id: module_name,
        option_id: option.id,
        startDate: option.date_range.startDate,
        value_id: option.selected_parent_option_id,
        endDate: option.date_range.endDate,
        multiple_value_id: option.selected_option_id,
        value_for: 0
      }
      await saveUserModuleAnalyticsSetting(updateData)
      this.$vs.loading.close()
      const msg = 'Saved successfully'
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    async submitPriceRange (option, module_name) {
      this.$vs.loading()
      const customer_id = localStorage.getItem('customer_id')
      const updateData = {
        customer_id,
        module_id: module_name,
        option_id: option.id,
        from_price: option.price_range[0],
        to_price: option.price_range[1],
        value_for: 0
      }
      await saveUserModuleAnalyticsSetting(updateData)
      this.$vs.loading.close()
      const msg = 'Saved successfully'
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    async statusHandleDropDownChange (project_id) {
      const data = await getStatusList(
        localStorage.getItem('customer_id'),
        project_id
      )
      this.project_status_list = data.data.data.project_status
    },
    async handleDateChnage (option, module_name, startDate, endDate) {
      this.$vs.loading()
      const customer_id = localStorage.getItem('customer_id')
      const updateData = {
        customer_id,
        module_id: module_name,
        option_id: option,
        startDate,
        endDate,
        value_for: 0
      }
      await saveUserModuleAnalyticsSetting(updateData)
      this.$vs.loading.close()
      const msg = 'Saved successfully'
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    async handleDropDownChnage (option, platform_modules_id) {
      this.$vs.loading()
      const customer_id = localStorage.getItem('customer_id')

      const updateData = {
        customer_id,
        module_id: platform_modules_id,
        option_id: option.id,
        value_id: option.selected_option_id,
        value_for: 0
      }
      await saveUserModuleAnalyticsSetting(updateData)
      this.$vs.loading.close()
      const msg = 'Saved successfully'
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    async toggleOptionSelected (platform_modules_id, option) {
      //this.$vs.loading()
      const customer_id = localStorage.getItem('customer_id')

      let msg = 'Option disabled successfully'
      if (option.enabled) {
        if (
          !option.has_dropdown &&
          !option.has_option_date_range &&
          !option.has_price_range
        ) {
          const updateData = {
            customer_id,
            module_id: platform_modules_id,
            option_id: option.id,
            value_id: option.has_dropdown ? option.selected_option_id : null,
            value_for: 0
          }
          await saveUserModuleAnalyticsSetting(updateData)
          msg = 'Option enabled successfully'
          //this.$vs.loading.close()
          this.$vs.notify({
            title: 'Success',
            text: msg,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        } else {
          //this.$vs.loading.close()
          msg = 'Choose an option'
          this.$vs.notify({
            title: 'Warning',
            text: msg,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        }
      } else {
        const deleteData = {
          customer_id,
          module_id: platform_modules_id,
          option_id: option.id,
          value_for: 0
        }
        await deleteUserModuleAnalyticsSetting(deleteData)

        this.$vs.notify({
          title: 'Success',
          text: msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      }
    },
    async getModuleList () {
      const { data } = await platformModuleslist()
      this.moduleList = data.data.modules_list
      this.moduleList = this.moduleList.map((element) => {
        if (element.platform_modules_id === 15) {
          return {
            ...element,
            module_name: 'Rooms',
            stats: [],
            isLoaded: false
          }
        } else if (element.platform_modules_id === 44) {
          return {
            ...element,
            module_name: 'Inventory',
            stats: [],
            isLoaded: false
          }
        } else {
          return {
            ...element,
            stats: [],
            isLoaded: false
          }
        }
      })
    },
    async getPlatformModulesAndMapSettings (platform_modules_id, isload) {
      //this.$vs.loading()
      try {
        const index = this.moduleList.findIndex((moduleItem) => {
          return moduleItem.platform_modules_id === platform_modules_id
        })
        if (!isload) {
          const summary_id = 0
          const customer_id = localStorage.getItem('customer_id')
          const data = await getModuleAnalyticsSettings(
            platform_modules_id,
            customer_id,
            summary_id
          )

          this.moduleList[index].stats = data.data.data.analytics_options
          this.moduleList[index].isLoaded = true
          this.$vs.loading.close()
        }
      } catch (error) {}
    }
  }
}
</script>

<style>
</style>